module.exports = __webpack_public_path__ + "img/user-03.5c7677b4.jpg";